export default __webpack_public_path__ + "static/media/photo04_pc.49aa8d5f.jpg";